module.exports = __webpack_public_path__ + "static/img/Company-Program_Digitize_data.dab859f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/Company-Program_Digitize_data.jpg
// module id = INVZ
// module chunks = 0